// Display form of case / request numbers: "001-DNC-2026-0039" -> "26-0039".
// The full number stays stored (unique across teams) and is still used for links, keys and test ids.
const FULL = /^.+-(\d{2})(\d{2})-(\d{4,})$/;
const IN_TEXT = /\b[A-Z0-9]+(?:-[A-Z0-9]+)*-\d{2}(\d{2})-(\d{4,})\b/g;

export const shortNo = (n) => {
  if (!n) return n || "";
  const m = String(n).match(FULL);
  return m ? `${m[2]}-${m[3]}` : String(n);
};

// Shorten any full numbers inside older alert text (e.g. "Your submission 001-DNC-2026-0039 was approved.").
export const shortenNos = (text) => (text ? String(text).replace(IN_TEXT, (_, yy, seq) => `${yy}-${seq}`) : text);
